export default __webpack_public_path__ + "static/soehne-web-buch-15cadf47ef0f524bbab7867b50f40996.woff2";